/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb65Inputs */

const en__field_enum_pbs_fb65 = /** @type {(inputs: _Field_Enum_Pbs_Fb65Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 06 Faculty of Protestant Theology`)
};

const de__field_enum_pbs_fb65 = /** @type {(inputs: _Field_Enum_Pbs_Fb65Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 06 Evangelische Theologie`)
};

/**
* | output |
* | --- |
* | "F 06 Faculty of Protestant Theology" |
*
* @param {_Field_Enum_Pbs_Fb65Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb65 = /** @type {((inputs?: _Field_Enum_Pbs_Fb65Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb65Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb65(inputs)
	return de__field_enum_pbs_fb65(inputs)
});
export { _field_enum_pbs_fb65 as "_field_enum_PBS_FB6" }